module.exports = __webpack_public_path__ + "img/e0b2955.png";